import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm border-t border-gray-800" data-id="element-102">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-103">
        <p className="text-blue-400 font-bold mb-2" data-id="element-104">
          💙 "The best investment you can make is in your child's developing
          brain."
        </p>
        <p data-id="element-105">💙 THE LITTLE GENIUS SYSTEM™ — © 2026 — All rights reserved.</p>
        <p className="text-xs text-gray-500" data-id="element-106">
          Reproduction and redistribution prohibited without express
          authorization.
        </p>
        <div className="flex justify-center gap-4 pt-2" data-id="element-107">
          <a href="#" className="hover:text-white transition-colors" data-id="element-108">
            Privacy Policy
          </a>
          <span data-id="element-109">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-110">
            Terms & Conditions
          </a>
        </div>
      </div>
    </footer>;
}